import { FC } from 'react';
import { Field } from 'formik';
import { useTranslation } from 'mir-utils/i18n';
import { InputAdornment, SvgIcon, Tooltip } from '@mui/material';
import { mdiAlertOutline, mdiCheck } from '@mdi/js';
import Icon from '@mdi/react';
import { PhoneNumberField } from './PhoneNumberField';

const IconPhoneNumberNotConfirmed: FC = () => {
  const { t } = useTranslation();

  return (
    <Tooltip title={t('The number has not been confirmed')} disableInteractive>
      <SvgIcon color="warning" sx={{ cursor: 'pointer' }}>
        <Icon path={mdiAlertOutline} />
      </SvgIcon>
    </Tooltip>
  );
};

const IconPhoneNumberConfirmed: FC = () => {
  const { t } = useTranslation();

  return (
    <Tooltip title={t('The number has been confirmed')} disableInteractive>
      <SvgIcon color="success" sx={{ cursor: 'pointer' }}>
        <Icon path={mdiCheck} />
      </SvgIcon>
    </Tooltip>
  );
};

type Props = {
  name: string;
  isPhoneConfirmed: boolean;
  onValueChange?: () => void;
  isIconShown: boolean;
};

export const IdecoPhoneNumberField: FC<Props> = ({
  name,
  isPhoneConfirmed,
  onValueChange,
  isIconShown,
}) => {
  const { t } = useTranslation();

  return (
    <Field
      onValueChange={onValueChange}
      name={name}
      component={PhoneNumberField}
      helperText={t('Format: “plus” (+), country code, area code and local phone number')}
      InputProps={{
        endAdornment: isIconShown && (
          <InputAdornment position="end">
            {isPhoneConfirmed ? <IconPhoneNumberConfirmed /> : <IconPhoneNumberNotConfirmed />}
          </InputAdornment>
        ),
      }}
    />
  );
};
